import * as React from "react";
import { memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExclamationCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 10
	}), /* @__PURE__ */ _jsx("path", { d: "M12 8v4M12 16h.01" })]
});
const Memo = memo(SvgExclamationCircle);
export default Memo;
